import { createStore, applyMiddleware } from "redux";
import {thunk} from "redux-thunk"; // Import redux-thunk
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import rootReducer from "../reducer/index"; // Assuming your rootReducer combines all reducers
import storage from "redux-persist/lib/storage"; // Import storage from redux-persist

// Persist configuration
const persistConfig = {
  key: "root",
  storage, 
   // Local storage or session storage
};

// Wrap rootReducer with persistence
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Redux store with middleware applied
export const store = createStore(
  persistedReducer,
  applyMiddleware(thunk) // Apply redux-thunk middleware here
);

export const persistor = persistStore(store);
